import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import { getUserToken } from '../reducers/user/selectors';

export default WrappedComponent => {
  const IsAuthenticated = ({ userToken, ...props }) => {
    if (!userToken) {
      return <Redirect to={'/admin/login'} />;
    }

    return <WrappedComponent {...props} />;
  };

  return connect((state) => ({
    userToken: getUserToken(state),
  }))(IsAuthenticated);
};



// WEBPACK FOOTER //
// ./src/utils/isAuthenticated.js